// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"3427": "787acab70836","408": "c19335558442","6863": "454c9f289029","8357": "dd422574e14d","9066": "c1fdd6703d84","9576": "d22e217d04af",}[chunkId] + ".css"
}